import {
    CannedQuestionName,
    InteractiveQuestion,
} from '../../api/models/survey';
import { SELECTED_QUESTION_GROUP_BUYER } from '../../models/survey';
import { CheckoutState } from '../../state';
import { WithSurveyNamespace } from '../../state/survey';
import { createSelector } from '../utils/selector';
import {
    getBillingZipCode,
    getInteractiveQuestionsByAttendeeId,
} from './pureSelectors';

export const getHasQuebecQSTTaxQuestion = createSelector<
    boolean,
    (
        interactiveQuestionsByAttendeeId: Record<
            string,
            Array<InteractiveQuestion>
        >,
    ) => boolean
>(
    (state: WithSurveyNamespace) => getInteractiveQuestionsByAttendeeId(state),
    (
        interactiveQuestionsByAttendeeId: Record<
            string,
            Array<InteractiveQuestion>
        >,
    ) =>
        !!interactiveQuestionsByAttendeeId[SELECTED_QUESTION_GROUP_BUYER]?.find(
            ({ questionId }) => questionId === CannedQuestionName.qstZipCode,
        ),
);

export const getAnswersForQuestionsAffectingQuebecQSTTaxes = (
    surveyAnswers: Record<string, Record<string, string>>,
    state: CheckoutState,
) => ({
    [CannedQuestionName.bill]: {
        postal: getBillingZipCode(state),
    },
    [CannedQuestionName.taxRegistrationId]:
        surveyAnswers[SELECTED_QUESTION_GROUP_BUYER]?.[
            CannedQuestionName.taxRegistrationId
        ] ?? '',
    [CannedQuestionName.qstZipCode]:
        surveyAnswers[SELECTED_QUESTION_GROUP_BUYER]?.[
            CannedQuestionName.qstZipCode
        ] ?? '',
});
